import { render } from "./AddArticleDialog.vue?vue&type=template&id=26800d62&scoped=true&ts=true"
import script from "./AddArticleDialog.vue?vue&type=script&lang=ts"
export * from "./AddArticleDialog.vue?vue&type=script&lang=ts"

import "./AddArticleDialog.vue?vue&type=style&index=0&id=26800d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26800d62"]])

export default __exports__